import {TOGGLE_LEFT_SIDEBAR} from './types';

export function toggleLeftSidebarOpen() {
  return dispatch => {
    return dispatch({
      type: TOGGLE_LEFT_SIDEBAR
    })
  }
}